/**
 * A panel anchored to a row is wrong the moment the row moves.
 *
 * Registered with `capture: true` because a scroll inside the application's own scrolling panel
 * does not bubble to window, and that panel is exactly where the anchored rows live.
 */

import { useEffect } from 'react';

export function useDismissOnScroll(active: boolean, onDismiss: () => void): void {
  useEffect(() => {
    if (!active) return;
    const dismiss = () => onDismiss();
    document.addEventListener('scroll', dismiss, { capture: true, passive: true });
    window.addEventListener('resize', dismiss, { passive: true });
    return () => {
      document.removeEventListener('scroll', dismiss, { capture: true });
      window.removeEventListener('resize', dismiss);
    };
  }, [active, onDismiss]);
}
